import { UIBrandedFare, UIFetchStatus, UIClientFetchError } from "@flights/types";

export type BaseFareOfferToken = string;
export type BrandedFare = {
  baseOfferToken?: string;
  fetchStatus: UIFetchStatus;
  error?: UIClientFetchError;
  brandedFareOffers?: Array<UIBrandedFare>;
};

export type State = {
  fareOffersWithDetails: Record<BaseFareOfferToken, BrandedFare>;
  selectedFareToken?: string;
};

export const getInitialState = (): State => ({
  fareOffersWithDetails: {},
  selectedFareToken: undefined
});
